<template>

  <div  class="ma-2">
    <v-row   class="ma-0 pa-0">
      <v-col class="ma-0 pa-0">
        <div class="versionName">{{diffs.textDiff1.versionName}}</div>
        <div>
          <span
              class="diffname"
              v-for="(item, index) in leftNameDiffHtml"
              :key="index"
              :class=" item.op === -1 ? `del` : item.op === 1 ? `add` :`normal`">
        {{ item.data }}
        </span>
        </div>
      </v-col>
      <v-col  class="ma-0 pa-0">
        <div class="versionName">{{diffs.textDiff2.versionName}}</div>
        <div>
          <span
              class="diffname"
              v-for="(item, index) in rightNameDiffHtml"
              :key="index"
              :class=" item.op === -1 ? `del` : item.op === 1 ? `add` :`normal`">
          {{ item.data }}
        </span>
        </div>
      </v-col>
    </v-row>
    <v-divider class="mt-1 mb-1"/>
    <v-row   class="ma-0 pa-0">
      <v-col  class="ma-0 pa-0">

        <div>
          <span
              class="difftext"
              v-for="(item, index) in leftTextDiffHtml"
              :key="index"
              :class=" item.op === -1 ? `del` : item.op === 1 ? `add` :`normal`"
              v-html="newline(item.data)">
        </span>
        </div>

      </v-col>
      <v-col  class="ma-0 pa-0">
        <div>
          <span
              class="difftext"
              v-for="(item, index) in rightTextDiffHtml"
              :key="index"
              :class=" item.op === -1 ? `del` : item.op === 1 ? `add` :`normal`"
              v-html="newline(item.data)">

        </span>
        </div>
      </v-col>
    </v-row>
  </div>

</template>

<script>
import DiffMatchPatch from 'diff-match-patch';
import dayjs from "dayjs";

const dmp = new DiffMatchPatch();
export default {
  name: "TextDiff",
  props: ["diffs"],

  data() {
    return {
      nameHtml: null,
      leftNameDiffHtml: null,
      rightNameDiffHtml: null,
      leftTextDiffHtml: null,
      rightTextDiffHtml: null
    }
  },
  watch: {
    diffs: {
      handler() {
        if (this.diffs && this.diffs.textDiff1 && this.diffs.textDiff2) {
          this.calcName()
          this.calcText()
        }

      },immediate:true
    }
  },
  methods: {
    newline: function (text) {
      return text.replace(/\n/g, '<br>')
    },
    calcName() {
      let lines1 = (this.diffs.textDiff1.name ? this.diffs.textDiff1.name : "");
      let lines2 = (this.diffs.textDiff2.name ? this.diffs.textDiff2.name : "");
      let diffs = dmp.diff_main(lines1, lines2);
      dmp.diff_cleanupSemantic(diffs);

      let leftDiffHtml = [];
      let rightDiffHtml = [];
      diffs.forEach(([op, data]) => {
        switch (op) {
          case -1: // DIFF_DELETE
            leftDiffHtml.push({op: op, data: data})
            break;
          case 1: // DIFF_INSERT
            rightDiffHtml.push({op: op, data: data})
            break;
          case 0: // DIFF_EQUAL
            rightDiffHtml.push({op: op, data: data})
            leftDiffHtml.push({op: op, data: data})
            break;
        }
      });
      this.leftNameDiffHtml = leftDiffHtml;
      this.rightNameDiffHtml = rightDiffHtml;
    },
    calcText() {
      let lines1 = (this.diffs.textDiff1.content ? this.diffs.textDiff1.content : "");
      let lines2 = (this.diffs.textDiff2.content ? this.diffs.textDiff2.content : "");
      let diffs = dmp.diff_main(lines1, lines2);
      dmp.diff_cleanupSemantic(diffs);
      let leftDiffHtml = [];
      let rightDiffHtml = [];
      diffs.forEach(([op, data]) => {
        switch (op) {
          case -1: // DIFF_DELETE
            leftDiffHtml.push({op: op, data: data})
            break;
          case 1: // DIFF_INSERT
            rightDiffHtml.push({op: op, data: data})
            break;
          case 0: // DIFF_EQUAL
            rightDiffHtml.push({op: op, data: data})
            leftDiffHtml.push({op: op, data: data})
            break;
        }
      });
      this.leftTextDiffHtml = leftDiffHtml;
      this.rightTextDiffHtml = rightDiffHtml;
    }
  }
}
</script>

<style scoped>
.diffname{
  font-size: 14px;
}
.del{
  background-color: #ffd7d7;
}
.add{
  background-color: #abffd5 ;
}
.difftext{
  font-size: 12px;
}
.versionName{
  font-size: 14px;
  background-color:  var(--v-bordercolor-base);
}
</style>